export default __webpack_public_path__ + "static/media/firstPlace.743d5bb6.png";